import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Avatar,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DASHBOARD, CARD_COLORS } from "../../shared/constants";

const tiles = [
  {
    id: 1,
    label: DASHBOARD.ADMIN,
    initial: "A",
    color: CARD_COLORS.ADMIN,
    path: "/admin/users",
  },
  {
    id: 2,
    label: DASHBOARD.AIPLAYGROUND,
    initial: "P",
    color: CARD_COLORS.AIPLAYGROUND,
    path: "/admin/ai-playground",
  },
  {
    id: 3,
    label: DASHBOARD.SCHEDULEMESSAGES,
    initial: "S",
    color: CARD_COLORS.AIPLAYGROUND,
    path: "/admin/schedule-messages",
  },
  {
    id: 4,
    label: DASHBOARD.INSIGHTS,
    initial: "I",
    color: CARD_COLORS.INSIGHTS,
    path: "/admin/insights",
  },
  {
    id: 5,
    label: DASHBOARD.TEST_ENVIRONMENT,
    initial: "T",
    color: CARD_COLORS.INSIGHTS,
    path: "/admin/test-environment",
  },
  {
    id: 6,
    label: DASHBOARD.PLANS,
    initial: "P",
    color: CARD_COLORS.AIPLAYGROUND,
    path: "/admin/payment/plans",
  },
  {
    id: 7,
    label: DASHBOARD.PAYMENTS,
    initial: "P",
    color: CARD_COLORS.ADMIN,
    path: "/admin/payments",
  },
  {
    id: 8,
    label: DASHBOARD.UIRECOMMENDATIONS,
    initial: "P",
    color: CARD_COLORS.ADMIN,
    path: "/ui_recommendations",
  },
];

const Dashboard = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ fontFamily: "Poppins", p: 3 }}>
      <Typography variant="h5" fontWeight="bold" mb={2}>
        {DASHBOARD.PAGE_TITLE}
      </Typography>

      <Typography variant="body1" mb={3}>
        {DASHBOARD.WELCOME_MESSAGE}
      </Typography>

      <Grid container spacing={3}>
        {tiles.map((tile) => (
          <Grid item xs={12} sm={3} key={tile.id}>
            <Card
              sx={{
                textAlign: "center",
                cursor: "pointer",
                borderRadius: 3,
                boxShadow: 2,
                height: "220px",
                alignContent: "center",
                "&:hover": { boxShadow: 5 },
              }}
              onClick={() => navigate(tile.path)}
            >
              <CardContent>
                <Avatar
                  sx={{
                    bgcolor: tile.color,
                    mx: "auto",
                    width: 56,
                    height: 56,
                    fontSize: 24,
                  }}
                >
                  {tile.initial}
                </Avatar>
                <Typography variant="h6" fontWeight="bold" mt={2}>
                  {tile.label}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Dashboard;
